import { DateTime } from "luxon";
import {
  FunctionCreateDay,
  FunctionCreateDayPlusOne,
  FunctionCreateHour,
  toISO,
} from "../../../utils/useFunction";
import { ARRAY_DATE } from "../function/Busket.GenerateDate";

const BasketFindNextSlot = (props) => {
  const { selected, calendars, thisDate, self } = props;

  const filterSlotStillLeft = calendars?.filter((cal) => {
    // console.log("THIS MILI :", {
    //   d: DateTime.fromISO(cal?.day).setLocale("th").setZone("UTC+7").toMillis(),
    //   left: cal?.season_mix_planned - cal?.season_mix_booked,
    //   cal,
    //   thisD: DateTime.fromISO(toISO(thisDate.date))
    //     .setLocale("th")
    //     .setZone("UTC+7")
    //     .toMillis(),
    //   thisDate,
    // });

    return (
      cal?.season_mix_planned - cal?.season_mix_booked > 0 &&
      cal?.showDate !== thisDate?.date &&
      (cal?.status === false) &
        (DateTime.fromISO(String(cal?.day).slice(0, 10))
          .setLocale("th")
          .setZone("UTC+7")
          .toMillis() >
          DateTime.fromISO(toISO(thisDate.date))
            .setLocale("th")
            .setZone("UTC+7")
            .toMillis())
    );
  });

  let present =
    FunctionCreateHour() > 17
      ? FunctionCreateDayPlusOne()
      : FunctionCreateDay();

  let createFuture = new Array(20).fill("").map((_, i) => {
    const thisTime = DateTime.now()
      .setLocale("th")
      .setZone("UTC+7")
      .startOf("day")
      .plus({ days: i + 1 })
      .toISO()
      .slice(0, 10)
      .split("-");

    return `${
      Number(thisTime[1]) +
      "." +
      Number(thisTime[2]) +
      "." +
      Number(thisTime[0])
    }`;
  });

  const result = createFuture.map((date, index) => {
    const findSelf = calendars.find((o) => o?.showDate === date);

    const ios_bug_format = date?.replaceAll(".", "/");
    const objectDate = new Date(ios_bug_format);

    const res = {
      date: date,
      month: Number(date.split(".")[0]),
      name: ARRAY_DATE[objectDate.getDay()],
      disabled:
        findSelf?.status === true
          ? true
          : false ||
            (findSelf?.season_mix_planned - findSelf?.season_mix_booked > 0
              ? false
              : true),
      filter: index < present,
      day: Number(date.split(".")[1]),
      year: Number(date.split(".")[2]),
      time: new Date(ios_bug_format).getTime(),
    };

    return res;
  });

  //   console.log("filterSlotStillLeft", filterSlotStillLeft);

  if (filterSlotStillLeft?.length > 0) {
    return result.find((o) => o?.date === filterSlotStillLeft[0]?.showDate);
  } else {
    return false;
  }
};

export default BasketFindNextSlot;
